export function loadTopics(detail) {
  return {
    type: 'LOAD_TOPICS',
    detail,
  };
}
